<div nz-col class="ppl-step-main pl-2 pt-1" [nzBordered]="false">
    <form nz-form [formGroup]="additionalDemoForm" class="ppl-p0">
        @if(isAttrAvailable('isSnapReceived')){
        <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isSnapReceived"
                class="ppl-form-label">
            <span id="isSnapReceived-label" [attr.aria-label]="getAttributes('isSnapReceived').label">
                {{getAttributes('isSnapReceived').label}}
                @if(getAttributes('isSnapReceived').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
                </span>
    </nz-form-label>
            <nz-form-control [nzSm]="8" class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('isSnapReceived')?.tooltip || ''"
                    nzTooltipPlacement="topRight">
                    <nz-radio-group formControlName="isSnapReceived" class="ppl-radio-group" id="isSnapReceived"
                        [ngClass]="{'error': validationErrors['isSnapReceived'] }"
                        role="radiogroup" pplSelectedRadioFocus aria-labelledby="isSnapReceived-label">
                        @for(opt of radioBooleanOptions; track $index){
                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                        }
                    </nz-radio-group>
                </div>
                @if (validationErrors['isSnapReceived']) {
                <span class="pl-1 error-message">{{validationErrors['isSnapReceived']}}</span>
                }
            </nz-form-control>
        </nz-form-item>}
        @if(isAttrAvailable('isTanfReceived')){
        <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isTanfReceived"
                class="ppl-form-label"><span id="isTanfReceived-label" [attr.aria-label]="getAttributes('isTanfReceived').label">
                {{getAttributes('isTanfReceived').label}}
                @if(getAttributes('isTanfReceived').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
                </span>
        </nz-form-label>
            <nz-form-control [nzSm]="8" class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('isTanfReceived')?.tooltip || ''"
                    nzTooltipPlacement="topRight">
                    <nz-radio-group formControlName="isTanfReceived" class="ppl-radio-group" id="isTanfReceived" 
                    pplSelectedRadioFocus role="radiogroup" aria-labelledby="isTanfReceived-label"
                        [ngClass]="{'error': validationErrors['isTanfReceived'] }">
                        @for(opt of radioBooleanOptions; track $index){
                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                        }
                    </nz-radio-group>
                </div>
                @if (validationErrors['isTanfReceived']) {
                <span class="pl-1 error-message">{{validationErrors['isTanfReceived']}}</span>
                }
            </nz-form-control>
        </nz-form-item>}
        @if(isAttrAvailable('isSsiReceived')){
        <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isSsiReceived"
                class="ppl-form-label">
            <span id="isSsiReceived-label" [attr.aria-label]="getAttributes('isSsiReceived').label">
                {{getAttributes('isSsiReceived').label}}
                @if(getAttributes('isSsiReceived').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
                </span>
        </nz-form-label>
            <nz-form-control [nzSm]="8" class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('isSsiReceived')?.tooltip || ''"
                    nzTooltipPlacement="topRight">
                    <nz-radio-group formControlName="isSsiReceived" class="ppl-radio-group" id="isSsiReceived" pplSelectedRadioFocus
                        role="radiogroup" aria-labelledby="isSsiReceived-label"
                        [ngClass]="{'error': validationErrors['isSsiReceived'] }">
                        @for(opt of radioBooleanOptions; track $index){
                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                        }
                    </nz-radio-group>
                </div>
                @if (validationErrors['isSsiReceived']) {
                <span class="pl-1 error-message">{{validationErrors['isSsiReceived']}}</span>
                }
            </nz-form-control>
        </nz-form-item>}
        @if(isAttrAvailable('isUnemployed')){
        <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isUnemployed"
                class="ppl-form-label">
            <span id="isUnemployed-label" [attr.aria-label]="getAttributes('isUnemployed').label">
                {{getAttributes('isUnemployed').label}}
                @if(getAttributes('isUnemployed').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
                </span>
            </nz-form-label>
            <nz-form-control [nzSm]="8" class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('isUnemployed')?.tooltip || ''"
                    nzTooltipPlacement="topRight">
                    <nz-radio-group formControlName="isUnemployed" class="ppl-radio-group" id="isUnemployed"
                    pplSelectedRadioFocus role="radiogroup" aria-labelledby="isUnemployed-label"
                        [ngClass]="{'error': validationErrors['isUnemployed'] }">
                        @for(opt of radioBooleanOptions; track $index){
                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                        }
                    </nz-radio-group>
                </div>
                @if (validationErrors['isUnemployed']) {
                <span class="pl-1 error-message">{{validationErrors['isUnemployed']}}</span>
                }
            </nz-form-control>
        </nz-form-item>}
        @if(isAttrAvailable('isVeteran')){
        <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isVeteran"
                class="ppl-form-label">
            <span id="isVeteran-label" [attr.aria-label]="getAttributes('isVeteran').label">
                {{getAttributes('isVeteran').label}}
                @if(getAttributes('isVeteran').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
                </span>
        </nz-form-label>
            <nz-form-control [nzSm]="8" class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('isVeteran')?.tooltip || ''"
                    nzTooltipPlacement="topRight">
                    <nz-radio-group formControlName="isVeteran" class="ppl-radio-group" id="isVeteran" pplSelectedRadioFocus
                        role="radiogroup" aria-labelledby="isVeteran-label" 
                        [ngClass]="{'error': validationErrors['isVeteran'] }">
                        @for(opt of radioBooleanOptions; track $index){
                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                        }
                    </nz-radio-group>
                </div>
                @if (validationErrors['isVeteran']) {
                <span class="pl-1 error-message">{{validationErrors['isVeteran']}}</span>
                }
            </nz-form-control>
        </nz-form-item>}
        @if(isAttrAvailable('isDisabilityComp') && additionalDemoForm.get('isVeteran')?.value){
        <nz-form-item class="ppl-form-item">
            <nz-form-label [nzSm]="16" [nzXs]="24" nzFor="isDisabilityComp"
                class="ppl-form-label">
            <span id="isDisabilityComp-label" [attr.aria-label]="getAttributes('isDisabilityComp').label">
                {{getAttributes('isDisabilityComp').label}}
                @if(getAttributes('isDisabilityComp').mandatory === 'Y'){
                <span [attr.aria-label]="'Required'">*</span>
                }
                </span>
            </nz-form-label>
            <nz-form-control [nzSm]="8" class="ppl-form-control">
                <div nz-tooltip [nzTooltipTitle]="getAttributes('isDisabilityComp')?.tooltip || ''"
                    nzTooltipPlacement="topRight">
                    <nz-radio-group formControlName="isDisabilityComp" class="ppl-radio-group" id="isDisabilityComp"
                    pplSelectedRadioFocus role="radiogroup" aria-labelledby="isDisabilityComp-label"
                        [ngClass]="{'error': validationErrors['isDisabilityComp'] }">
                        @for(opt of radioBooleanOptions; track $index){
                        <label nz-radio-button [nzValue]="opt.value">{{opt.label}}</label>
                        }
                    </nz-radio-group>
                </div>
                @if (validationErrors['isDisabilityComp']) {
                <span class="pl-1 error-message">{{validationErrors['isDisabilityComp']}}</span>
                }
            </nz-form-control>
        </nz-form-item>}
        @if(isAttrAvailable('isWotcCertified')) {
            <nz-form-item class="ppl-form-item">
              <nz-form-control class="ppl-form-control mb-0">
                <nz-row [nzGutter]="8" nzAlign="middle" nzJustify="start" class="f-flex">
                  <nz-col [nzXs]="2" [nzSm]="1">
                    <input
                      nz-input
                      type="checkbox"
                      class="checkbox"
                      formControlName="isWotcCertified"
                      id="isWotcCertified"
                    />
                  </nz-col>
                  <nz-col [nzXs]="22" [nzSm]="23">
                    <label
                      [attr.for]="'isWotcCertified'"
                      class="ppl-form-label"
                    >
                      {{ getAttributes('isWotcCertified').label }}
                    </label>
                  </nz-col>
                </nz-row>
          
                @if(validationResponse && !validationResponse.valid) {
                  <p>
                    <span class="pl-1 error-message">{{ validationResponse.message }}</span>
                  </p>
                }
              </nz-form-control>
            </nz-form-item>
          }
          
          
        <div class="custom-row" style="width: 100%;">
            <ppl-button (click)="updateDemographics()" style="margin-right: 8px;" label="Save" [disabled]="disableSaveButton"
                icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
        </div>
    </form>
</div>